import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Briefcase, MapPin, Clock, ChevronRight } from 'lucide-react';
import './CareersPage.css';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const CareersPage = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    try {
      const response = await fetch(`${API_URL}/api/careers`);
      if (response.ok) {
        const data = await response.json();
        setJobs(data);
      }
    } catch (error) {
      console.error('Error fetching jobs:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="careers-page">
      {/* Hero Section */}
      <section className="careers-hero">
        <div className="container">
          <h1 className="careers-hero-title">Join Our Team</h1>
          <p className="careers-hero-subtitle">
            Be part of a creative team that transforms stories into visual masterpieces
          </p>
        </div>
      </section>

      {/* Jobs Section */}
      <section className="careers-content section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Open Positions</h2>
            <p className="section-subtitle">
              Explore current opportunities at RSE Post Production House
            </p>
          </div>

          {loading ? (
            <div className="careers-loading">
              <div className="spinner"></div>
              <p>Loading positions...</p>
            </div>
          ) : jobs.length === 0 ? (
            <div className="no-jobs">
              <Briefcase size={48} />
              <h3>No Open Positions</h3>
              <p>We don't have any open positions right now, but check back soon!</p>
            </div>
          ) : (
            <div className="jobs-list">
              {jobs.map((job) => (
                <Link to={`/careers/${job.id}`} key={job.id} className="job-card">
                  <div className="job-card-content">
                    <h3 className="job-title">{job.job_title}</h3>
                    <div className="job-meta">
                      <span className="job-meta-item">
                        <MapPin size={16} />
                        {job.location}
                      </span>
                      <span className="job-meta-item">
                        <Clock size={16} />
                        {job.job_type}
                      </span>
                      <span className="job-meta-item">
                        <Briefcase size={16} />
                        {job.experience}
                      </span>
                    </div>
                    <p className="job-description">
                      {job.description.substring(0, 150)}...
                    </p>
                  </div>
                  <div className="job-card-arrow">
                    <ChevronRight size={24} />
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Why Join Section */}
      <section className="why-join section">
        <div className="container">
          <h2 className="section-title">Why Join RSE?</h2>
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon">🎬</div>
              <h3>Creative Freedom</h3>
              <p>Work on diverse projects from weddings to corporate films</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">📈</div>
              <h3>Growth Opportunities</h3>
              <p>Learn from industry experts and advance your career</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">🌍</div>
              <h3>Global Exposure</h3>
              <p>Work with clients from USA, UK, Canada & Australia</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">💼</div>
              <h3>Competitive Package</h3>
              <p>Attractive salary with performance bonuses</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CareersPage;
